import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const VerifyEmail = () => {
  const [message, setMessage] = useState("Verifying your email...");
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");

    if (!token) {
      setMessage("Invalid verification link.");
      return;
    }

    const verifyEmail = async () => {
      try {
        const response = await axios.get(
          `https://abha.ai/api/app/verify-email/?token=${token}`
        );

        // if (response.status === 100) {
          // ⏳ Wait 2 seconds, then redirect to success page
        setTimeout(() => {
        navigate(`/verify-success?email=${response.data.email}`);
        }, 2000);
        // }
      } catch (error) {
        console.error(error);
        setMessage("❌ Verification failed or link expired.");
        toast.error("Verification failed. Please try again.");
      }
    };

    verifyEmail();
  }, [navigate]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <h2>{message}</h2>
      <ToastContainer position="bottom-center" />
    </div>
  );
};

export default VerifyEmail;
